import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type DeleteModuleCompletionMutationVariables = Types.Exact<{
  moduleKey: Types.Scalars['String']['input'];
}>;


export type DeleteModuleCompletionMutation = { __typename?: 'mutation_root', delete_learning_module_completions?: { __typename?: 'learning_module_completions_mutation_response', affected_rows: number } | null };


export const DeleteModuleCompletionDocument = gql`
    mutation DeleteModuleCompletion($moduleKey: String!) {
  delete_learning_module_completions(where: {module_key: {_eq: $moduleKey}}) {
    affected_rows
  }
}
    `;
export type DeleteModuleCompletionMutationFn = Apollo.MutationFunction<DeleteModuleCompletionMutation, DeleteModuleCompletionMutationVariables>;

/**
 * __useDeleteModuleCompletionMutation__
 *
 * To run a mutation, you first call `useDeleteModuleCompletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModuleCompletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModuleCompletionMutation, { data, loading, error }] = useDeleteModuleCompletionMutation({
 *   variables: {
 *      moduleKey: // value for 'moduleKey'
 *   },
 * });
 */
export function useDeleteModuleCompletionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteModuleCompletionMutation, DeleteModuleCompletionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteModuleCompletionMutation, DeleteModuleCompletionMutationVariables>(DeleteModuleCompletionDocument, options);
      }
export type DeleteModuleCompletionMutationHookResult = ReturnType<typeof useDeleteModuleCompletionMutation>;
export type DeleteModuleCompletionMutationResult = Apollo.MutationResult<DeleteModuleCompletionMutation>;
export type DeleteModuleCompletionMutationOptions = Apollo.BaseMutationOptions<DeleteModuleCompletionMutation, DeleteModuleCompletionMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/learningCenter/queries/deleteModuleCompletion.mutation.gql}
 */
export async function deleteModuleCompletion(
  variables: DeleteModuleCompletionMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<DeleteModuleCompletionMutation['delete_learning_module_completions']>
export async function deleteModuleCompletion(
  variables: DeleteModuleCompletionMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<DeleteModuleCompletionMutation>
export async function deleteModuleCompletion(
  variables: DeleteModuleCompletionMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<DeleteModuleCompletionMutation['delete_learning_module_completions'] | DeleteModuleCompletionMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<DeleteModuleCompletionMutation>(
    DeleteModuleCompletionDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.delete_learning_module_completions
}